// css =>
import "../../BaseStructure.css";
import Styled from "./WelcomePageFromSignIn.module.css";

// react =>
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// componenets =>
import Header from "../../Components/header/header.comp";

function WelcomePageFromSignIn() {

    const navigate = useNavigate();

    useEffect(() => {
        document.title = "خوش آمدید";

        const timer = setTimeout(() => {
            navigate("/edit-profile");
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            <Header />

            <br /><br /><br /><br />

            <div className="row" id={ Styled.WelcomeSecionFrame }>
                <div className="col-12">
                    <h1>حساب کاربری شما فعال شد!</h1>
                    <h3>از همراهی شما در فروشگاه آنلاین محصولات چرمی ویدوک سپاسگذاریم.</h3>
                </div>

                <div className="col-12">
                    <p style={{ color: 'rgb(225, 229, 204)' }}>لطفا مشخصات خود را در حساب کاربری تکمیل نمایید.</p>
                    <p>در حال انتقال به حساب کاربری...</p>
                </div>
            </div>

            {/* <div className="row">
                <div className="col-6">
                    <button style={{ backgroundColor: '' }} onClick={() => {
                        navigate("/edit-profile");
                    }}>
                        <h3>تکمیل کردن مشخصات</h3>
                    </button>
                </div>
                <div className="col-6">
                    <button style={{ backgroundColor: '' }} onClick={() => {
                        navigate("/");
                    }}>
                        <h3>انتقال به سایت بدون تکمیل مشخصات</h3>
                    </button>
                </div>
            </div> */}
        </>
    );
};

export default WelcomePageFromSignIn;
